const styles = () => ({
  root: {
    paddingLeft: 40,
    paddingRight: 40,
  },

  header: {
    display: 'flex',
  },

  title: {
    alignSelf: 'center',
    width: '40%',
    margin: 0,
    fontWeight: 'normal',
    fontSize: '20px',
    color: '#414953',
  },

  filter: {
    width: '80%',
    marginLeft: 'auto',
    marginTop: 0,
    marginBottom: 0,
  },

  filterRoot: {
    margin: 0,
  },

  pills: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },

  pill: {
    backgroundColor: '#f1f1f1',
    borderRadius: 4,
    marginRight: 5,
    padding: '3px 6px',
    marginBottom: 4,
    whiteSpace: 'pre',
  },

  tableTitle: {
    paddingLeft: 0,
  },

  tableTitleInner: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginRight: 6,
    },
  },

  tableKey: {
    width: '40%',
    flex: 'auto',
  },

  tableValue: {
    width: '60%',
    flex: 'auto',
    wordBreak: 'break-word',
  },
});

export default styles;
